import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API_ROUTES } from "../../utils/apiConfig/apiRoutes";
import { apiPost } from "../../utils/apiConfig/apiService";
import { startCapitalize } from "../../utils/commonfunction";
import { routesName } from "../../routes/routesName";
import { formatDate } from "../../utils/DateAndFormat";

export const analyticsDataToDataBase = createAsyncThunk(
  "analytics",
  async (data = {}, { getState = () => null, dispatch = () => null }) => {
    try {
      const state = getState();
      const sessionId = state?.Patientdetails?.sessionId;
      if (!sessionId) return;
      let windowPath = window.location.pathname;
      const utm = state?.Patientdetails?.utm;
      const isSendedPayload = state?.Patientdetails?.isPassedPayLoad;
      const clientId = state?.Patientdetails?.rulesConfig?.[0]?.clientid;
      const ruleid = state?.Patientdetails?.rulesConfig?.[0]?.ruleid;
      const location =
        state?.servicetype?.location?.LocationId === "anyActiveLocation"
          ? null
          : state?.servicetype?.location?.LocationId;
      const locationSource = state?.servicetype?.locationSource ?? null;

      const IsWidget = state?.frames?.isIframe;
      const isLandingPage = windowPath.includes(routesName.LANDING);
      let appointmentTypeId =
        clientId === 162 && !isLandingPage
          ? state?.Patientdetails?.selectedSubService?.appointmentTypeId ??
            state?.servicetype?.servicetype?.appointmentTypeId
          : state?.servicetype?.servicetype?.appointmentTypeId;
      let providerId = state?.Patientdetails?.selectedProvider?.providerId;
      const isExistingPatient = state?.Patientdetails?.isExistingPatient;

      let {
        eventLabel = undefined,
        pageName: page = "",
        isAptBooked = undefined,
        rwgToken,
        cancel = undefined,
        newPath = windowPath,
        action = undefined,
        provider_id = providerId,
        appointmentTypeId2 = appointmentTypeId,
        alert = undefined,
        patientType = isExistingPatient,
        locationId = location,
        ...others
      } = data;
      if (
        newPath.includes(routesName.IDENTITY) ||
        newPath.includes(routesName.LANDING)
      ) {
        provider_id = undefined;
      }

      let pagePath = newPath.split("/");
      let lastPath = pagePath?.[pagePath?.length - 1];
      pagePath = newPath.replace(lastPath, page);
      const isInIframe = window.self !== window.top;
      const isWidget = document.querySelector("layline-widget");

      const pageName = startCapitalize(page) || undefined;
      const mergeData = {
        sessionId,
        clientId,
        ruleid,
        pagePath,
        pageName,
        eventLabel,
        action,
        locationId,
        alert,
        //test
        appointmentTypeId: appointmentTypeId2,
        clickPagePath: newPath,
        clickPageName: startCapitalize(lastPath) || undefined,
        providerId: provider_id,
        eventDetails: others,
        isExistingPatient: patientType == null ? undefined : patientType,
        googleSessionDetails: {
          utmSource: utm?.utm_source || undefined,
          utmMedium: utm?.utm_medium || undefined,
          utmCampaign: utm?.utm_campaign || "website",
          utmTerm: utm?.utm_term || undefined,
          rwgToken,
        },
        utm_source: utm?.utm_source || undefined,
        utm_medium: utm?.utm_medium || undefined,
        utm_campaign: utm?.utm_campaign || undefined,
        utm_term: utm?.utm_term || undefined,
        isAptBooked,
        channelFilters: isInIframe
          ? "frames"
          : isWidget
            ? "frames"
            : utm?.channel || "website",
        rwgToken,
        ...(locationSource && { locationSource }),
      };
      if (isSendedPayload) {
        delete mergeData.googleSessionDetails;
      }

      await apiPost(API_ROUTES?.POST_ANALYTICS, mergeData, cancel);
      // if (utm?.utm_source && !isSendedPayload) {
      //   dispatch(updatePassedPayLoad(true));
      // }
      if (!isSendedPayload) {
        dispatch(updatePassedPayLoad(true));
      }
    } catch (error) {
      console.error(error);
    }
  },
);
let autoSaveInFlight = false;
export const autoSaveIntakeSession = createAsyncThunk(
  "patient/autoSaveIntakeSession",
  async (payload = {}, { getState }) => {
    if (autoSaveInFlight) return;

    try {
      const state = getState();

      const sessionId = state?.Patientdetails?.sessionId;
      const clientId = state?.Patientdetails?.rulesConfig?.[0]?.clientid;
      const ruleid = state?.Patientdetails?.rulesConfig?.[0]?.ruleid;
      const locationSource = state?.servicetype?.locationSource ?? null;
      if (!sessionId) return;

      // Remove null / undefined / empty values
      const cleanedPayload = Object.fromEntries(
        Object.entries(payload)?.filter(
          ([_, value]) => value !== null && value !== undefined && value !== "",
        ),
      );

      // If nothing valid to send, stop API call
      if (Object.keys(cleanedPayload).length === 0) return;

      const params = {
        clientId,
        sessionId,
        ruleid,
        ...(locationSource && { locationSource }),
        ...cleanedPayload,
      };

      autoSaveInFlight = true;
      await apiPost(API_ROUTES.POST_USER_SESSION_UPDATE, params);

      return true;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      autoSaveInFlight = false;
    }
  },
);
const patientSlice = createSlice({
  name: "patientdetails",
  initialState: {
    patients: [],
    patientdetail: [],
    selectedProvider: null,
    isExistingPatient: null,
    insurancePolicy: null,
    selectedTime: [],
    liveSelectedTime: [],
    nextSubServicePopup: null,
    rulesConfig: [],
    sessionId: null,
    ownSession: null,
    contentValue: 64,
    utm: null,
    isPassedPayLoad: false,
    pageLoader: true,
    patientFromShortUrlData: null,
    showWarningStatus: "pending",
    patientFilters: {},
    patientSearchQuery: "",
    patientTabValue: "filter",
    provider: null,
    IntakeQuestion: "",
    selectedSubService: null,
    IntakeCondition: [],
    IntakeReferrer: null,
    IntakeSymptoms: [],
    Intakedisruptive: null,
    IntakeDynamicQuestions: [],
    leadFormData: null,
    findApptLoader: true,
    userUpdate: false,
    newPatientInsuranceDraft: null,
    newPatientPersonalData: null,
    widgetStorage: null,
    checkinForms: null,
    checkinPreviews: null,
    isFrameSelection: false,
    activeFrameSlotIndex: 0,
    frameSelectionConsumed: false,
  },
  reducers: {
    patientValue: (state, action) => {
      state.patients = action.payload;
    },
    updateFindApptLoader: (state, action) => {
      state.findApptLoader = action.payload;
    },
    updateRulesConfig: (state, action) => {
      state.rulesConfig = action.payload;
    },
    updateLeadFormData: (state, action) => {
      state.leadFormData = action.payload;
    },
    updateNewPatientInsuranceDraft: (state, action) => {
      state.newPatientInsuranceDraft = action.payload;
    },
    updateNewPatientPersonalData: (state, action) => {
      state.newPatientPersonalData = action.payload;
    },

    updateIntakeQuestion: (state, action) => {
      state.IntakeQuestion = action.payload;
    },
    updateIntakeCondition: (state, action) => {
      state.IntakeCondition = action.payload;
    },
    updateIntakeReferrer: (state, action) => {
      state.IntakeReferrer = action.payload;
    },
    updateIntakeSymptoms: (state, action) => {
      state.IntakeSymptoms = action.payload;
    },
    updateIntakedisruptive: (state, action) => {
      state.Intakedisruptive = action.payload;
    },
    updateIntakeDynamicQuestions: (state, action) => {
      state.IntakeDynamicQuestions = action.payload;
    },
    removepatientValue: (state, action) => {
      state.patients = [];
      state.patientdetail = [];
      state.selectedProvider = null;
      state.provider = null;
      state.isExistingPatient = false;
      state.insurancePolicy = null;
      state.selectedTime = [];
      state.activeFrameSlotIndex = 0;
      // state.rulesConfig = [];
      state.IntakeQuestion = "";
      state.selectedSubService = null;
      state.IntakeCondition = "";
      state.IntakeReferrer = null;
      state.IntakeSymptoms = [];
      state.Intakedisruptive = null;
      state.IntakeDynamicQuestions = [];
      state.newPatientInsuranceDraft = null;
      state.newPatientPersonalData = null;
      state.checkinForms = null;
      state.checkinPreviews = null;
    },
    patientdetailsValue: (state, action) => {
      state.patientdetail = action.payload;
    },
    updateSelectedProvider: (state, action) => {
      state.selectedProvider = action.payload;
    },
    updateselectedTime: (state, action) => {
      state.selectedTime = action.payload;
    },
    updateIsFrameSelection: (state, action) => {
      state.isFrameSelection = action.payload;
    },
    updateActiveFrameSlotIndex: (state, action) => {
      state.activeFrameSlotIndex = action.payload;
    },
    updateFrameSlotAtIndex: (state, action) => {
      const { index, slot } = action.payload;
      if (Array.isArray(state.selectedTime) && state.selectedTime[index]) {
        state.selectedTime[index] = { ...state.selectedTime[index], ...slot };
      }
    },
    updateFrameSelectionConsumed: (state, action) => {
      state.frameSelectionConsumed = action.payload;
    },
    updateLiveSelectedTime: (state, action) => {
      state.liveSelectedTime = action.payload
    },
    updateNextSubServicePopup: (state, action) => {
      state.nextSubServicePopup = action.payload
    },
    updateIsExistingPatient: (state, action) => {
      state.isExistingPatient = action.payload;
    },
    updateInsurancePolicy: (state, action) => {
      state.insurancePolicy = action.payload;
    },
    updateSessionId: (state, action) => {
      state.sessionId = action.payload;
    },
    updateOwnSession: (state, action) => {
      state.ownSession = action.payload;
    },
    updateContentValue: (state, action) => {
      state.contentValue = action.payload;
    },
    updateUTM: (state, action) => {
      state.utm = action.payload;
    },
    updatePassedPayLoad: (state, action) => {
      state.isPassedPayLoad = action.payload;
    },
    updatePageLoader: (state, action) => {
      state.pageLoader = action.payload;
    },
    updatePatientFromShortUrlData: (state, action) => {
      state.patientFromShortUrlData = action.payload;
    },
    updateShowWarningStatus: (state, action) => {
      state.showWarningStatus = action.payload;
    },
    updatePatientFilters: (state, action) => {
      state.patientFilters = action.payload;
    },
    updatePatientSearchQuery: (state, action) => {
      state.patientSearchQuery = action.payload;
    },
    updatePatientTabValue: (state, action) => {
      state.patientTabValue = action.payload;
    },
    clearPatientFilters: (state) => {
      state.patientFilters = {};
      state.patientSearchQuery = "";
      state.patientTabValue = "filter";
    },
    // NEW: Action to reset entire patient state on logout
    resetPatientState: (state) => {
      state.patients = [];
      state.patientdetail = [];
      state.selectedProvider = null;
      state.provider = null;
      state.isExistingPatient = null;
      state.insurancePolicy = null;
      state.selectedTime = [];
      state.rulesConfig = [];
      state.sessionId = null;
      state.contentValue = 64;
      state.utm = null;
      state.isPassedPayLoad = false;
      state.pageLoader = true;
      state.IntakeDynamicQuestions = [];
      // Clear patient filters
      state.patientFilters = {};
      state.patientSearchQuery = "";
      state.patientTabValue = "filter";
      state.checkinForms = null;
      state.checkinPreviews = null;
    },
    updateSubService: (state, action) => {
      state.selectedSubService = action.payload;
    },
    updateProvider: (state, action) => {
      state.provider = action.payload;
    },
    updateUserSelect: (state, action) => {
      state.userUpdate = action.payload;
    },
    updateWidgetStorage: (state, action) => {
      state.widgetStorage = action.payload;
    },
    updateCheckinFormDoc: (state, action) => {
      const { docId, patch } = action.payload || {};
      if (!docId) return;
      state.checkinForms = {
        ...(state.checkinForms || {}),
        [docId]: { ...(state.checkinForms?.[docId] || {}), ...(patch || {}) },
      };
    },
    clearCheckinForms: (state) => {
      state.checkinForms = null;
      state.checkinPreviews = null;
    },
    updateCheckinPreview: (state, action) => {
      const { formId, contentType, data, url } = action.payload || {};
      if (!formId || (!data && !url)) return;
      state.checkinPreviews = {
        ...(state.checkinPreviews || {}),
        [formId]: {
          contentType: contentType || "application/pdf",
          ...(data ? { data } : {}),
          ...(url ? { url } : {}),
          fetchedAt: Date.now(),
        },
      };
    },
    clearCheckinPreview: (state, action) => {
      const formId = action?.payload?.formId;
      if (!formId || !state.checkinPreviews) return;
      const next = { ...state.checkinPreviews };
      delete next[formId];
      state.checkinPreviews = next;
    },
  },
});

export default patientSlice.reducer;
export const {
  patientValue,
  updateInsurancePolicy,
  updateRulesConfig,
  updateselectedTime,
  updateIsFrameSelection,
  updateActiveFrameSlotIndex,
  updateFrameSlotAtIndex,
  updateFrameSelectionConsumed,
  updateLiveSelectedTime,
  updateNextSubServicePopup,
  patientdetailsValue,
  updateSelectedProvider,
  updateIsExistingPatient,
  removepatientValue,
  updateSessionId,
  updateContentValue,
  updateUTM,
  updatePassedPayLoad,
  updatePageLoader,
  updatePatientFromShortUrlData,
  updateShowWarningStatus,
  updatePatientFilters,
  updatePatientSearchQuery,
  updatePatientTabValue,
  clearPatientFilters,
  resetPatientState, // NEW: Export the reset action
  updateIntakeQuestion,
  updateSubService,
  updateIntakeCondition,
  updateIntakeReferrer,
  updateIntakeSymptoms,
  updateIntakedisruptive,
  updateIntakeDynamicQuestions,
  updateLeadFormData,
  updateFindApptLoader,
  updateProvider,
  updateUserSelect,
  updateOwnSession,
  updateNewPatientInsuranceDraft,
  updateNewPatientPersonalData,
  updateWidgetStorage,
  updateCheckinFormDoc,
  clearCheckinForms,
  updateCheckinPreview,
  clearCheckinPreview
} = patientSlice.actions;
